import React from 'react';
import PropTypes from 'prop-types';
import * as S from './Tooltip.styles.js';

import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import P from '../Texts/P/P';

const Tooltip = ({ position, showArrow, children, msg, show, align }) => {
  const positionTranslate = {
    top: 'top',
    right: 'right',
    bottom: 'bottom',
    left: 'left',
    'top-right': 'top-end',
    'top-left': 'top-start',
    'bottom-right': 'bottom-end',
    'bottom-left': 'bottom-start',
  };

  const alignText = {
    top: 'center',
    right: 'left',
    bottom: 'center',
    left: 'right',
    'top-right': 'left',
    'top-left': 'right',
    'bottom-right': 'left',
    'bottom-left': 'right',
  };

  const ChildrenWrapper = () => (
    <OverlayTrigger
      placement={positionTranslate[position]}
      overlay={
        <S.TooltipOverlay position={position}>
          <S.TooltipWrapper data-testid='tooltip' position={position}>
            <S.TooltipMessage>
              <P
                type='4'
                variant='neutral'
                modifier='inverted'
                align={align ? align : alignText[position]}
              >
                {msg}
              </P>
            </S.TooltipMessage>
            {showArrow && (
              <S.TooltipArrow data-testid='tooltip-arrow' position={position} />
            )}
          </S.TooltipWrapper>
        </S.TooltipOverlay>
      }
    >
      {({ ref, ...triggerHandler }) => (
        <S.ChildrenWrapper {...triggerHandler} ref={ref}>
          {children}
        </S.ChildrenWrapper>
      )}
    </OverlayTrigger>
  );

  return (
    <S.Tooltip position={position} msg={msg} showArrow={showArrow} show={show}>
      {ChildrenWrapper()}
    </S.Tooltip>
  );
};

Tooltip.defaultProps = {
  position: 'top',
  size: 'md',
  showArrow: true,
};

Tooltip.propTypes = {
  position: PropTypes.oneOf([
    'top',
    'right',
    'bottom',
    'left',
    'top-right',
    'top-left',
    'bottom-right',
    'bottom-left',
  ]),
  showArrow: PropTypes.bool,
  show: PropTypes.bool,
  msg: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  align: PropTypes.oneOf(['center', 'right', 'left']),
};
export default Tooltip;
